// ** Dropdowns Imports
// ** Third Party Components
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Wallet from "@store/actions/wallet";
import { Moon, Sun } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { Button, CardText, Media, NavItem, NavLink } from "reactstrap";
import IntlDropdown from "./IntlDropdown";

const NavbarUser = (props) => {
  // ** Props
  const { skin, setSkin } = props;
  const dispatch = useDispatch();
  const store = useSelector((state) => state.wallet);

  const wallet = new Wallet();

  // ** Function to toggle Theme (Light/Dark)
  const ThemeToggler = () => {
    if (skin === "dark") {
      return <Sun className="ficon" onClick={() => setSkin("light")} />;
    } else {
      return <Moon className="ficon" onClick={() => setSkin("dark")} />;
    }
  };

  return (
    <>
      <ul className="nav navbar-nav align-items-center ml-auto">
        {store.bnbPrice > 0 && (
          <NavItem className="warning d-lg-block" style={{ marginRight: "10px" }}>
            <NavLink className="nav-link-style">
              <Media className="my-auto" body>
                <h4 className="mb-0">{`$${store.bnbPrice.toPrecision(3)}`}</h4>
                <CardText className="font-small-3 mb-0">$BNB</CardText>
              </Media>
            </NavLink>
          </NavItem>
        )}
        {store.bccPrice > 0 && (
          <NavItem className="warning d-lg-block" style={{ marginRight: "10px" }}>
            <NavLink className="nav-link-style">
              <Media className="my-auto" body>
                <h4 className="mb-0">{`$${store.bccPrice.toExponential(2)}`}</h4>
                <CardText className="font-small-3 mb-0">$BCC</CardText>
              </Media>
            </NavLink>
          </NavItem>
        )}
        <IntlDropdown />
        <NavItem className="d-lg-block">
          <NavLink className="nav-link-style">
            <ThemeToggler />
          </NavLink>
        </NavItem>
        {/* <CartDropdown /> */}
        {/* <NotificationDropdown /> */}
        {/* <UserDropdown /> */}
        {!wallet.isConnected() ? (
          <NavItem className="d-lg-block">
            <NavLink className="nav-link-style">
              <Button.Ripple
                onClick={async () => {
                  await wallet.connect();
                }}
                color="warning"
              >
                Connect
              </Button.Ripple>
            </NavLink>
          </NavItem>
        ) : (
          <>
            <NavItem className="d-lg-block d-none">
              <NavLink className="nav-link-style">
                <Button.Ripple color="warning">{wallet.addressShort()}</Button.Ripple>
              </NavLink>
            </NavItem>
            <NavItem className="d-lg-block">
              <NavLink className="nav-link-style">
                <Button.Ripple
                  onClick={async () => {
                    await wallet.disconnect();
                  }}
                  color="warning"
                >
                  <FontAwesomeIcon icon={faSignOutAlt} style={{ color: "#161a1f" }} />
                </Button.Ripple>
              </NavLink>
            </NavItem>
          </>
        )}
      </ul>
    </>
  );
};
export default NavbarUser;
